<template>
  <van-tag type="success" size="large" class="tag">
    <span>{{ text }}</span>
    <van-icon name="cross" class="delete" @click="handleClick" />
  </van-tag>
</template>
<script>
export default {
  props: {
    value: [String],
    text: [String],
  },
  mounted() {
    this.$el.scrollIntoView({ behavior: 'smooth', inline: 'end' });
  },
  methods: {
    handleClick() {
      this.$emit('delete', this.value);
    },
  },
};
</script>
<style lang="less" scoped>
.tag {
  margin: 1px 2px 1px 2px;
  /deep/.delete {
    vertical-align: middle;
    height: 16px;
    margin-left: 2px;
  }
}
</style>
